import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import pickupDayOrDate from './date-utils/pickup-day-or-date';
import invokeOrReturnString from './date-utils/invoke-or-return-string';
var string = PropTypes.string,
  func = PropTypes.func;

/**
 * PickupDayOrDate calculates whether to show Today, Tomorrow, date or range of dates
 *
 * @param {object} props - react props
 * @param {string} props.minPickupDate - earliest pickup date
 * @param {string} props.maxPickupDate - latest pickup date
 * @param {Function} props.pickupTodayMessage - translated Message  for today at
 * @param {Function} props.pickupTomorrowMessage - translated Message  for tomorrow at
 * @param {string} props.timeZone - timezone of latest arrival date
 * @param {string} props.language - language sensitive date and time formatting
 * @returns {React.Component} - today/tomorrow/pickupdate string based on given date
 */
var PickupDayOrDate = function PickupDayOrDate(_ref) {
  var minPickupDate = _ref.minPickupDate,
    maxPickupDate = _ref.maxPickupDate,
    pickupTodayMessage = _ref.pickupTodayMessage,
    pickupTomorrowMessage = _ref.pickupTomorrowMessage,
    timeZone = _ref.timeZone,
    language = _ref.language;
  var resolvedDate = pickupDayOrDate({
    minPickupDate: minPickupDate,
    maxPickupDate: maxPickupDate,
    timeZone: timeZone,
    language: language,
    pickupTodayMessage: pickupTodayMessage,
    pickupTomorrowMessage: pickupTomorrowMessage
  });
  return /*#__PURE__*/React.createElement(Fragment, null, invokeOrReturnString(resolvedDate));
};
PickupDayOrDate.propTypes = {
  minPickupDate: string,
  maxPickupDate: string,
  pickupTodayMessage: func,
  pickupTomorrowMessage: func,
  timeZone: string,
  language: string
};
export default /*#__PURE__*/React.memo(PickupDayOrDate);